import React, { memo } from 'react';
import { Handle } from 'react-flow-renderer';
import { useNodeStorage } from '../../../stores/useNodeStorage';
import { Typography, IconButton } from '@material-ui/core';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import DeleteIcon from '@material-ui/icons/Delete';
import FileCopyIcon from '@material-ui/icons/FileCopy';

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  const handleDelete = () => {
    storageItems.setNodesStorage(id);
    storageItems.setAct('delete');
  };

  const handleDuplicate = () => {
    storageItems.setNodesStorage(id);
    storageItems.setAct('duplicate');
  };

  return (
    <div
      style={{
        backgroundColor: '#fff',
        padding: 8,
        borderRadius: 8,
        minWidth: 180,
      }}
    >
      <Handle
        type='target'
        position='left'
        style={{ background: '#555' }}
        isConnectable={isConnectable}
      />

      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <ViewKanbanIcon fontSize='small' />
        <Typography variant='subtitle2' style={{ flex: 1 }}>
          Mover Kanban
        </Typography>
        <IconButton size='small' onClick={handleDuplicate}>
          <FileCopyIcon fontSize='small' />
        </IconButton>
        <IconButton size='small' onClick={handleDelete}>
          <DeleteIcon fontSize='small' />
        </IconButton>
      </div>

      <Typography variant='caption' color='textSecondary'>
        {data?.kanbanName
          ? `Destino: ${data.kanbanName}`
          : 'Nenhum kanban selecionado'}
      </Typography>

      <Handle
        type='source'
        position='right'
        style={{ background: '#555' }}
        isConnectable={isConnectable}
      />
    </div>
  );
});